'use client';

import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

type CardProps = {
  className?: string;
  children: React.ReactNode;
};

export default function Card({ className, children }: CardProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className={cn(
        'rounded-xl shadow-md overflow-hidden',
        'bg-white text-slate-900 shadow-slate-200/60',
        className
      )}
    >
      {children}
    </motion.div>
  );
}
